<template>
  <div id="videos">
    <v-container class="pa-0">
        <v-layout>
        <v-flex class="xs12 sm12 mb-5">
           <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
    </v-container>
    <v-form>
    <v-container mt-3 grid-list-md fluid v-if="helpVideoList.length > 0">
      <v-layout wrap row pb4>
          <v-flex xs12 sm6 md6 lg4 xl3 v-for="videoItem of helpVideoList" :key="videoItem.id" pa-2 >
            <v-card v-if="videoItem.url">
              <vue-plyr :options="options" v-if="videoItem.url.indexOf('vimeo.com') === -1">
                <div class="plyr__video-embed">
                  <iframe
                    :src="videoItem.url"
                    allowfullscreen allowtransparency allow="autoplay">
                  </iframe>
                </div>
              </vue-plyr>
              <vimeo-player v-else :video-url="videoItem.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>
              
              <v-flex class="pl-1 pr-1 mb-0">
                <h5 id="videoName" class="pa-1 title-display">
                  <div>
                    <span v-if="videoItem.title">{{ videoItem.title === '' ? 'Untitled' : videoItem.title }}</span>
                    <span v-else>Sample Title</span>
                  </div>
                </h5>
              </v-flex>
            </v-card>
          </v-flex>
        <v-flex xs6 sm6>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid v-if="helpVideoList.length == 0" class="text-center">
        <img src="static/NoVideos.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Video Found !! </b></h4>
    </v-container>
  </v-form>
  </div>
</template>
<script>
/* global session, store */
import { getCollection } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

Vue.use(VuePlyr);

import { vueVimeoPlayer } from 'vue-vimeo-player';

// This lists the help videos to the parents.
export default
{
  name: 'ListHelpVideos',
  components: {
    'vimeo-player': vueVimeoPlayer
  },
  data: vm => ({
    entity: 'HelpVideo',
    options: {
      controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen']
    },
    roleEntity: 'Account'
  }),
  computed: {
    ...mapGetters(['Account', 'Child']),
    helpVideoList: {
      get () {
        return store.state.VideoList;
      },
      set (value) {
        store.commit('setVideoList', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to fetch the help videos if not exists
    async initialize () {
      if (!this.helpVideoList.length) {
        if (typeof this[this.roleEntity].membership !== 'undefined') {
          let where = { membership: this[this.roleEntity].membership };
          let sort = { sort_no: 1 };
          let { error, data } = await getCollection(this.entity, true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else {
            if (data.length > 0) {
              this.helpVideoList = data;
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  .pf-divider {
    margin: 0 auto;
    width: 88%;
  }
  .upload-container{
    padding-top: 10px;
  }
  .pf-video-upload-btn{
    padding-left: 0;
    padding-right: 0;
  }
  .or-label{
    padding-top: 28px;
  }
  .title-display{
    padding-top: 6px !important;
  }
  .text-edit-field {
    padding-left: 4px;
    padding-bottom: 6px;
  }
  @media(max-width:576px){
    .or-label{
      padding-top: 0;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/HelpVideos/list.vue